import React from "react";
import {
  Rocket,
  LayoutDashboard,
  Zap,
  Globe,
  Sparkles,
  ShieldCheck,
  Lightbulb,
  Users,
  Code2,
  Target,
} from "lucide-react";

const qualities = [
  {
    icon: <Rocket size={30} />,
    title: "Modern Web Development",
    desc: "We build modern websites, web applications, SaaS platforms, and business systems using React.js, Node.js, MongoDB, Express.js, and scalable cloud technologies.",
  },
  {
    icon: <LayoutDashboard size={30} />,
    title: "SEO & Performance Optimization",
    desc: "Every website is developed with SEO best practices, Core Web Vitals optimization, mobile responsiveness, fast loading speeds, and scalable architecture.",
  },
  {
    icon: <Zap size={30} />,
    title: "Business Growth Solutions",
    desc: "Our digital solutions are designed to increase brand visibility, generate qualified leads, improve conversions, and support long-term business growth.",
  },
  {
    icon: <Globe size={30} />,
    title: "Cyber Security & Reliability",
    desc: "We follow secure development practices to protect websites, web applications, customer data, and business systems from modern security threats.",
  },
];

const values = [
  {
    icon: Sparkles,
    title: "Innovation",
  },
  {
    icon: ShieldCheck,
    title: "Security",
  },
  {
    icon: Lightbulb,
    title: "Creativity",
  },
  {
    icon: Users,
    title: "Client Success",
  },
  {
    icon: Code2,
    title: "Development",
  },
  {
    icon: Target,
    title: "Growth Focused",
  },
];

export default function QualityValuesSection() {
  return (
    <section className="relative py-16 px-4 sm:px-6 lg:px-16 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] text-gray-900 dark:text-white">
      {/* BG GLOW */}
      <div className="absolute top-0 left-0 w-[450px] h-[450px] bg-primary/10 blur-[140px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[450px] h-[450px] bg-orange-300/10 blur-[140px] rounded-full"></div>

      {/* GRID */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:60px_60px]"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16 ">
          <h2 className="myheading text-3xl md:text-5xl ">
            Premium Quality &
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
              {" "}
              Modern Standards
            </span>
          </h2>

          <p className="myparagraph  text-gray-600 dark:text-gray-400  max-w-3xl mx-auto">
            Focused on delivering scalable digital experiences through premium
            engineering, modern technologies, and innovation-driven workflows.
          </p>
        </div>

        {/* QUALITY CARDS */}
        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
          {qualities.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg border border-black/5 dark:border-white/10 bg-white/80 dark:bg-white/[0.04] backdrop-blur-2xl p-8 shadow-sm hover:shadow-2xl hover:-translate-y-2 transition-all duration-500"
            >
              {/* HOVER GLOW */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-br from-primary/5 via-orange-400/5 to-yellow-400/5"></div>

              <div className="relative z-10">
                <div className="flex gap-3 mb-2">
                  {/* ICON */}
                  <div className=" p-2 w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
                    {item.icon}
                  </div>

                  {/* TITLE */}
                  <h3 className=" text-md font-bold ">{item.title}</h3>
                </div>

                {/* DESC */}
                <p className="text-gray-600 dark:text-gray-400 text-sm">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* VALUES */}
        <div>
          {/* HEADING */}
          <div className="text-center pt-24">
            <div className="text-center mb-12 md:mb-16 ">
              <h2 className="myheading text-3xl md:text-5xl text-center">
                Our{" "}
                <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
                  Values
                </span>
              </h2>
              <p className="myparagraph text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                Our values drive innovation, collaboration, creativity, and
                long-term digital excellence.
              </p>
            </div>
          </div>

          {/* VALUE GRID */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
            {values.map((item, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-lg border border-black/5 dark:border-white/10 bg-white/80 dark:bg-white/[0.04] backdrop-blur-2xl p-5"
              >
                {/* HOVER EFFECT */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-br from-primary/5 via-orange-400/5 to-yellow-400/5"></div>

                <div className="relative z-10 flex flex-col items-center text-center">
                  {/* ICON */}
                  <div className="w-12 h-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-500">
                    <item.icon size={30} />
                  </div>

                  {/* TITLE */}
                  <h4 className="font-bold text-md">{item.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
